import { useMemo } from 'react'
import { CargosQuery, CargosQueryVariables } from '@/core/types/graphql'
import { CARGOS_QUERY } from '@/modules/usuarios-edicao/data/cargos'
import { OptionSelect } from '@/core/utils/types'
import { useQuery } from '@tanstack/react-query'
import { request } from '../../../core/utils/request'

export const useCargos = (cargosPrincipais: string[] = []) => {
  const { data, isLoading } = useQuery<CargosQuery, CargosQueryVariables>({
    queryKey: ['cargos', cargosPrincipais],
    queryFn: async () =>
      await request<CargosQuery, CargosQueryVariables>(CARGOS_QUERY, {
        variables: { cargosPrincipais }
      })
  })

  const cargos = useMemo(() => data?.cargos ?? [], [data])

  const cargosOptions = useMemo(
    () =>
      cargos.map(it => ({ label: it?.nome, value: it?.id })) as OptionSelect[],
    [cargos]
  )

  return {
    cargos,
    cargosOptions,
    hasCargos: cargos.length > 0,
    isLoading
  }
}
